import { render } from "./QuemSomos.vue?vue&type=template&id=4a05703e&scoped=true"
import script from "./QuemSomos.vue?vue&type=script&lang=js"
export * from "./QuemSomos.vue?vue&type=script&lang=js"

import "./QuemSomos.vue?vue&type=style&index=0&id=4a05703e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a05703e"]])

export default __exports__